import { type UseQueryLightError } from '@atlaskit/teams-client';
import { ErrorCategory, type HttpError, TeamProfileErrorType } from '@atlassian/ptc-common';

/**
 * User Profile page has error object as UseQueryLightError but Team Profile Page has error object as HttpError.
 * In User Profile page, find an error other than NotFound or NotPermitted.
 * In Team Profile page, find an error other than NO_PERMISSION or TEAM_MISSING or TEAM_DELETED.
 */
export const isRealErrorUserProfile = (error?: UseQueryLightError): boolean => {
	if (!error) {
		return false;
	}

	if (
		error?.message?.includes('User not found') ||
		error?.message?.includes('Access is denied') ||
		error?.message?.includes('TEAM CENTRAL UNAUTHORIZED')
	) {
		return false;
	}

	if (!error.graphQLErrors) {
		return true;
	}

	return !error.graphQLErrors.every(
		(e?) =>
			!e || e.category === ErrorCategory.NotFound || e.category === ErrorCategory.NotPermitted,
	);
};

export const errorUserNotFound = new Error('User not found');

export function parseErrorObjectToErrorCategory(
	error?: UseQueryLightError | Error,
): ErrorCategory | '' {
	if (!error) {
		return '';
	}

	if (error?.message === errorUserNotFound.message) {
		return ErrorCategory.NotFound;
	}

	return (error as UseQueryLightError).graphQLErrors?.[0]?.category || '';
}

const MAP_TEAM_STATUS_ERROR_TYPES_MAP: Record<number, TeamProfileErrorType> = {
	403: TeamProfileErrorType.NO_PERMISSION,
	404: TeamProfileErrorType.TEAM_MISSING,
	410: TeamProfileErrorType.TEAM_DELETED,
};

export const parseTeamErrorCategory = (error: HttpError | null) =>
	error ? MAP_TEAM_STATUS_ERROR_TYPES_MAP[error.status] || TeamProfileErrorType.UNKNOWN : null;
